import * as emoji from 'node-emoji';
import ApplicationController from './application_controller';

const escapeHtml = (value) => {
  const element = document.createElement('div');
  element.textContent = value;

  return element.innerHTML;
};

const toggleNotice = (notice, list, keys) => {
  if (keys.size === 0) {
    notice.classList.add('d-none');
    return;
  }

  list.textContent = [...keys].map((key) => `%{${key}}`).join(' ');
  notice.classList.remove('d-none');
};

// Connects to data-controller="notification-message-preview"
//
// 入力中の件名・本文の %{変数} をサンプル値に置き換えてプレビューする。
// 置換表 (varsValue) は CompanyNotificationMessage.build_vars から渡ってくるので、
// 実際の配信と同じ結果になる。置換表に無い変数は配信時に置き換わらないため警告する。
export default class extends ApplicationController {
  static targets = [
    'subjectInput', 'bodyInput', 'subject', 'body',
    'unknown', 'unknownVars', 'legacy', 'legacyVars',
  ];

  static values = { vars: Object, legacyKeys: Array, mention: Boolean };

  connect() {
    super.connect();

    this.render();
  }

  render() {
    const unknown = new Set();
    const legacy = new Set();

    if (this.hasSubjectTarget && this.hasSubjectInputTarget) {
      this.subjectTarget.innerHTML = this.substitute(this.subjectInputTarget.value, unknown, legacy);
    }
    if (this.hasBodyTarget && this.hasBodyInputTarget) {
      this.bodyTarget.innerHTML = this.substitute(this.bodyInputTarget.value, unknown, legacy, true);
    }

    toggleNotice(this.unknownTarget, this.unknownVarsTarget, unknown);
    toggleNotice(this.legacyTarget, this.legacyVarsTarget, legacy);
  }

  substitute(value, unknown, legacy, multiline = false) {
    let html = escapeHtml(emoji.emojify(value || ''));

    html = html.replace(/%\{(\w+)\}/g, (matched, key) => {
      if (!Object.hasOwn(this.varsValue, key)) {
        unknown.add(key);
        return `<mark class="preview-unknown-var">${matched}</mark>`;
      }

      if (this.legacyKeysValue.includes(key)) { legacy.add(key); }

      return escapeHtml(this.varsValue[key]);
    });

    // Slack のメンション (<@名前>) をメンションらしい見た目にする
    if (this.mentionValue) {
      html = html.replace(
        /&lt;(@[^&<>]+)&gt;/g,
        '<span class="slack-message-block-mention-highlight">$1</span>',
      );
    }

    return multiline ? html.replace(/\n/g, '<br>') : html;
  }
}
